import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgCursorResize = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "up left down right",
		filter: "url(#filter0_d_687_9761)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Shape",
			d: "M6.24 8.07L10.31 12.14L7.49 14.97L15.96 14.95L15.97 6.48L13.13 9.32L9.06 5.26L7.64 3.84L10.49 1H2V9.48L4.83 6.66L6.24 8.07Z",
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Shape_2",
			d: "M7.3 7.72L11.73 12.14L9.9 13.97L14.96 13.95L14.97 8.9L13.13 10.74L8.7 6.32L6.23 3.84L8.07 2H3V7.07L4.83 5.24L7.3 7.72Z",
			fill: "black"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_687_9761",
		x: .2,
		y: .2,
		width: 17.5702,
		height: 17.57,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .9 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_687_9761"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_687_9761",
				result: "shape"
			})
		]
	}) })]
});
export default SvgCursorResize;
